import { action } from 'mobx';
import { DisturbanceMap, DisturbanceNotifications } from '@config/DisturbanceConfig';
import API, { DISTURBANCE_BASE_URL } from '@util/ApiUtil';

export default class DisturbanceMapApi {
  private static async getMapResults(url: string): Promise<DisturbanceMap> {
    const results = await API.get(url);
    return results.data;
  }

  private static async getNotifications(url: string): Promise<DisturbanceNotifications> {
    const results = await API.get(url);
    return results.data;
  }

  @action
  public static getMap = (auth_type: string): Promise<DisturbanceMap> => {
    return DisturbanceMapApi.getMapResults(`${DISTURBANCE_BASE_URL}/${auth_type}/map`);
  };

  @action
  public static getNotices = (auth_type: string): Promise<DisturbanceNotifications> => {
    return DisturbanceMapApi.getNotifications(`${DISTURBANCE_BASE_URL}/${auth_type}/notifications`);
  };
}
